import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import { Box, Container, Grid, Paper, Stack, Typography } from "@mui/material";
import YourTickets from "../Checkout/YourTickets/YourTickets";
import { Divider } from "@/shared/base/components/Divider/Divider";
import React from "react";
import { PerksBase } from "./PerksBase";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";

export function SelectPerks() {
  const { sm: smDown } = useCssMediaQuery("down");
  const { uiConfigs, languages } = useTeamConfig();
  const hideAddOnsViewer = uiConfigs?.perks?.hideAddOnsViewer;
  const addOnsLabel = languages?.purchaseSeats?.addOnsLabel || "Add-Ons";

  return (
    <Container maxWidth="xl" sx={{ padding: smDown ? 0 : "inherit" }}>
      <Grid container spacing={"24px"} mb={8}>
        <Grid
          item
          md={6}
          sm={12}
          sx={{ width: "100%" }}
          display={hideAddOnsViewer ? "none" : "unset"}
        >
          <Paper variant="outlined" sx={{ minHeight: "100%" }}>
            <Stack
              direction="row"
              justifyContent={"space-between"}
              margin={"24px"}
            >
              <Typography fontWeight={700} fontSize={"24px"}>
                {addOnsLabel}
              </Typography>
            </Stack>
            <Divider />
            <Box p={3}>
              <PerksBase />
            </Box>
          </Paper>
        </Grid>
        <Grid
          item
          md={hideAddOnsViewer ? 12 : 6}
          sm={12}
          sx={{ width: "100%" }}
        >
          <YourTickets hideCollapseIcon={true} />
        </Grid>
      </Grid>
    </Container>
  );
}
